import { Container, Nav, Navbar, Offcanvas } from 'react-bootstrap';
import logo from '../../img/greenLogo.png';

function NavBar({ pageActive } : any) {
  return (
    <Navbar bg="white" expand="lg" fixed="top" className="mb-0 navbar-spaced">
      <Container fluid className={`d-flex flex-nowrap justify-content-between align-items-center w-100 ${pageActive === 1 || pageActive === undefined ? 'navbar-animation' : ''}`}>
        <Navbar.Brand href="/" className="me-0">
            <img src={logo} className="navbar-logo" alt="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls={`offcanvasNavbar`} />
        <Navbar.Offcanvas
          id={`offcanvasNavbar`}
          aria-labelledby={`offcanvasNavbarLabel`} 
          placement="end"
        >
          <Offcanvas.Header closeButton>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              <Nav.Link active={pageActive === 1 || pageActive === undefined ? true : false} href="/">Página Inicial</Nav.Link>
              <Nav.Link active={pageActive === 2 ? true : false} href="/sobre-mim">Sobre Mim</Nav.Link>
              <Nav.Link active={pageActive === 3 ? true : false} href="/consultorio">Consultório</Nav.Link>
              {/* <NavDropdown
                title="O que é Medicina Interna?"
                id={`offcanvasNavbarDropdown`}
              >
                <NavDropdown.Item href="#action3">
                    A Especialidade
                </NavDropdown.Item>
                <NavDropdown.Item href="#action4">
                    Principais doenças
                </NavDropdown.Item>
              </NavDropdown>  */}
            </Nav>
            {/* <Form className="d-flex">
              <Form.Control
                type="search"
                placeholder="Busca"
                className="me-2"
                aria-label="Search"
              />
              <Button variant="outline-primary" className="button-search">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </Button>
            </Form> */}
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}

export default NavBar;